export const mapParamFallback = { lat: 52.5, lng: 13.4, zoom: 12.1 }
